'use client';
import AppImage from '@/components/ui/AppImage';

interface Photo {
  id: string;
  image: string;
  alt: string;
  title: string;
  category: string;
  date: string;
}

interface PhotoGridProps {
  photos: Photo[];
  onPhotoClick: (index: number) => void;
}

export default function PhotoGrid({ photos, onPhotoClick }: PhotoGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {photos.map((photo, index) => (
        <button
          key={photo.id}
          onClick={() => onPhotoClick(index)}
          className="group relative overflow-hidden rounded-2xl aspect-square cursor-pointer"
        >
          <AppImage
            src={photo.image}
            alt={photo.alt}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
            <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
              {photo.category}
            </span>
            <h3 className="text-lg font-bold text-white mt-1">{photo.title}</h3>
            <p className="text-xs text-muted-foreground mt-1">{photo.date}</p>
          </div>
        </button>
      ))}
    </div>
  );
}
